import { MissingTranslationHandler, MissingTranslationHandlerParams, StrictTranslation } from '@ngx-translate/core';

/** Prefix prepended to unresolved translation keys (e.g. `"Missing Key: MY_KEY"`). */
export const MISSING_KEY_PREFIX = 'Missing Key: ';

/**
 * Default handler for missing translation keys in ngx-translate.
 *
 * Returns the missing key prefixed with {@link MISSING_KEY_PREFIX} so unresolved
 * translations are visible in the UI during development.
 *
 * Supports an `ifEmpty` interpolation param as a fallback mechanism:
 * when a translation pipe passes `{ ifEmpty: value },`, the handler returns
 * that value instead of the prefixed key.
 *
 * Usage: `{{ 'KEY' | translate: { ifEmpty: 'fallback' } }}`
 */
export class RsMissingTranslationHandler implements MissingTranslationHandler {
  /**
   * Resolves a missing translation key.
   *
   * @returns The `ifEmpty` interpolation value if provided, otherwise `MISSING_KEY_PREFIX + key`.
   */
  public handle(params: MissingTranslationHandlerParams): StrictTranslation {

    if (params.interpolateParams && 'ifEmpty' in params.interpolateParams) {
      return params.interpolateParams['ifEmpty'] as StrictTranslation;
    }

    return MISSING_KEY_PREFIX + params.key;
  }
}
